export default __webpack_public_path__ + "static/updateVideo-ec1eda14e6463431c8463907d8b4059a.mp4";